// Import model
import { UpdateLead2Request } from '../models/UpdateLead2Request';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { UpdateSfLeadRequest } from '../models/UpdateSfLeadRequest';

// Import dependency serializers (for complex types)
import { UpdateSfLeadRequestSerializer } from './UpdateSfLeadRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateLead2Request - handles JSON serialization and deserialization with type validation
 */
export class UpdateLead2RequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateLead2Request instance
   */
  static deserialize(json: string): UpdateLead2Request {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateLead2Request instance
   */
  static fromObject(obj: any): UpdateLead2Request {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateLead2Request');
    }


    const instance: UpdateLead2Request = {
      externalId: obj['externalId'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      properties: obj['properties'] ? UpdateSfLeadRequestSerializer.fromObject(obj['properties']) : undefined as any,
      flowId: obj['flowId'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateLead2Request instances
   */
  static deserializeArray(json: string): UpdateLead2Request[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateLead2Request instance to a JSON string
   */
  static serialize(instance: UpdateLead2Request): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateLead2Request instance to a plain object
   */
  static toObject(instance: UpdateLead2Request): any {
    return {
      'externalId': instance.externalId,
      'isActive': instance.isActive,
      'properties': instance.properties ? UpdateSfLeadRequestSerializer.toObject(instance.properties) : undefined,
      'flowId': instance.flowId,
      'objectStatusId': instance.objectStatusId,
    };
  }

  /**
   * Serializes an array of UpdateLead2Request instances to a JSON string
   */
  static serializeArray(instances: UpdateLead2Request[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
